'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        marginLeft: "-10px",
    },
    label: {
        fontSize: variables.SIZES.TEXT_MEDIUM,
    },
};

var MuiFormControlLabel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiFormControlLabel = MuiFormControlLabel;
exports.light = light;
